var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import MuiPopper from '@material-ui/core/Popper';
import MuiFade from '@material-ui/core/Fade';
import MuiPaper from '@material-ui/core/Paper';
var Popper = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(MuiPopper, _extends({}, rest, {
    transition: true,
    ref: ref,
    style: {
      zIndex: 9999
    }
  }), function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/React.createElement(MuiFade, _extends({}, TransitionProps, {
      timeout: 350
    }), /*#__PURE__*/React.createElement(MuiPaper, {
      elevation: 3,
      style: {
        margin: 5
      }
    }, children));
  });
});
Popper.propTypes = {
  /**
   * An HTML element, virtualElement, or a function which is used to set the position of the popper.
   */
  anchorEl: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.node.isRequired,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Placement of popper
   */
  placement: PropTypes.oneOf(['auto-end', 'auto-start', 'auto', 'bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
};
Popper.defaultProps = {
  anchorEl: null,
  open: false,
  disablePortal: false,
  placement: 'bottom'
};
export default Popper;